import React, { useState } from "react";
import styles from "./hoverContent.module.scss";

const HoverContent = () => {
  const [leftHover, setLeftHover] = useState(true);
  const [rightHover, setRightHover] = useState(false);
  const [click, setClick] = useState("home");

  function getRight(params) {
    setRightHover(true);
    setLeftHover(false);
  }
  return (
    <div className={styles.container} id="services">
      <div className={styles.videoContainer}>
        <video
          src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SECTION_02/section02BackgroundVideo.mp4"
          className={styles.video}
          autoPlay
          muted
          loop
        />
      </div>
      <h2 className={styles.mainHeading}>We will Provide Service</h2>
      <div className={styles.wrapper}>
        <div
          className={
            leftHover
              ? styles.left + " " + styles.largeDiv + " " + styles.leftLarge
              : styles.left + " " + styles.smallDiv + " " + styles.leftSmall
          }
          onMouseOver={() => setLeftHover(true)}
          onMouseOut={() => setLeftHover(false)}
        >
          {leftHover ? (
            <div className={styles.contentWrapper}>
              <h3 className={styles.heading}>
                Servers installed at your office
              </h3>
              <div className={styles.text}>
                Yes we also set up servers in ur office as well technical team
                will come to your site and fix the server for your data base
                needed it will more help for your cost optimization and data
                base theft production.
              </div>
            </div>
          ) : (
            <h3 className={styles.title}>In Office</h3>
          )}
        </div>
        <div
          className={
            rightHover
              ? styles.right + " " + styles.largeDiv + " " + styles.rightLarge
              : styles.right + " " + styles.smallDiv + " " + styles.rightSmall
          }
          onMouseOver={getRight}
          onMouseOut={() => setRightHover(false)}
        >
          {rightHover ? (
            <div className={styles.contentWrapper}>
              <h3 className={styles.heading}>Servers set up at your home</h3>
              <div className={styles.text}>
                Yes you read it right we set up servers in your home, team will
                come to your site and fix the server for your data base needed
                it will more help for your cost optimization and data base theft
                production.
              </div>
            </div>
          ) : (
            <h3 className={styles.title}>In Home</h3>
          )}
        </div>
      </div>
      <div
        className={`${styles.mobileWrapper} ${
          click === "home" ? styles.homeBackground : styles.officeBackground
        }`}
      >
        <div className={styles.textWrapper}>
          {click === "home" ? (
            <>
              <h3 className={styles.heading}>Servers set up at your home</h3>
              <div className={styles.text}>
                Yes you read it right we set up servers in your home, team will
                come to your site and fix the server for your data base needed
                it will more help for your cost optimization and data base theft
                production.
              </div>
            </>
          ) : (
            <>
              <h3 className={styles.heading}>
                Servers installed at your office
              </h3>
              <div className={styles.text}>
                Yes we also set up servers in ur office as well technical team
                will come to your site and fix the server for your data base
                needed it will more help for your cost optimization and data
                base theft production.
              </div>
            </>
          )}
        </div>
        <div className={styles.buttonGroup}>
          <div
            className={`${
              click === "home" ? styles.leftButton : styles.invisible
            } ${styles.leftBtnBackground}`}
            onClick={() => setClick("office")}
          >
            <p>In Office</p>
          </div>
          <div className={styles.divider}></div>
          <div
            className={`${
              click === "office" ? styles.rightButton : styles.invisible
            } ${styles.rightBtnBackground}`}
            onClick={() => setClick("home")}
          >
            In Home
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoverContent;
